import { api } from "./api";
import type { BagSale } from "@/types/models";
import type { SalePaymentLine } from "@/hooks/useSalePayments";

interface PaginatedResponse<T> {
  data: T[];
  meta: {
    total: number;
    limit: number;
    offset: number;
  };
}

export const bagSaleService = {
  create: (data: {
    date: string;
    bag_type: string;
    qty: number;
    rate_per_unit: number;
    total_amount: number;
    buyer_id?: number;
    /** Owner-only approval for a sale that breaches the buyer's credit terms. */
    credit_override?: boolean;
    buyer?: string;
    notes?: string;
    payments?: SalePaymentLine[];
  }) =>
    api
      .post<{ success: boolean; data: BagSale }>("/bag-sales", data)
      .then((r) => r.data),
  list: (params?: Record<string, string | number>) =>
    api
      .get<PaginatedResponse<BagSale>>("/bag-sales", { params })
      .then((r) => r.data),
  get: (id: number) =>
    api
      .get<{ success: boolean; data: BagSale }>(`/bag-sales/${id}`)
      .then((r) => r.data),
  update: (id: number, data: {
    date: string;
    bag_type: string;
    qty: number;
    rate_per_unit: number;
    total_amount: number;
    buyer_id?: number;
    /** Owner-only approval for a sale that breaches the buyer's credit terms. */
    credit_override?: boolean;
    buyer?: string;
    notes?: string;
  }) =>
    api
      .put<{ success: boolean; data: BagSale }>(`/bag-sales/${id}`, data)
      .then((r) => r.data),
  // confirmPaid: the owner has seen "money has been paid on this sale" and
  // said delete.
  delete: (id: number, confirmPaid = false) =>
    api.delete(`/bag-sales/${id}`, { params: confirmPaid ? { confirm_paid: "true" } : undefined }).then((r) => r.data),
};
